import React, { useEffect, useState, useContext } from 'react'
import MenuAdmin from './navAdmin/Menu'
import Footer from '../footer/Footer'
import Home from "../public/Home";

function Admin ()  {
    return(
        <>
            <Home roleUser={'Admin'}/>
            {/* <Footer /> */}
        </>
    )
}

export default Admin